import React, { useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { moveColumn, orderedColumns } from "reduxSlices/taskReportBuilderSlice"
import { DraggableColumnTypes } from "ReportBuilder/DragAndDrop/DraggableColumnTypes"
import SelectedColumn from "ReportBuilder/SelectedColumn"
import useScrollToAdded from "ReportBuilder/DragAndDrop/useScrollToAdded"
import SelectionDropZone from "ReportBuilder/DragAndDrop/SelectionDropZone"

const Selections = () => {
  const dispatch = useDispatch()
  const ref = useRef(null)
  const selections = useSelector(orderedColumns)

  useScrollToAdded(ref, selections)

  const handleMoveColumn = (column, toIndex) => {
    dispatch(moveColumn({ column, toIndex }))
  }

  return (
    <SelectionDropZone
      acceptableTypes={DraggableColumnTypes.TASK_REPORT_COLUMN_SELECTION}
      ref={ref}
    >
      {
        selections.map((column, index) => (
          <SelectedColumn
            key={`${column.type}-${column.id}`}
            column={{ ...column, index }}
            dragType={DraggableColumnTypes.TASK_REPORT_COLUMN_SELECTION}
            moveColumn={handleMoveColumn}
          />
        ))
      }
    </SelectionDropZone>
  )
}

export default Selections
